import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import HomePage from './components/HomePage';
import RSVPPage from './components/RSVPPage';
import TravelDetails from './components/TravelDetails';
import RegistryDetails from './components/RegistryDetails';
import MobileNavigation, { MobileMenuProvider, useMobileMenu } from './components/MobileNavigation';
import { AuthProvider } from './contexts/AuthContext';
import { RSVPProvider } from './contexts/RSVPContext';
import { colors } from './styles/colors';

// Global styles to handle overscroll area
const GlobalStyle = createGlobalStyle`
  :root {
    /* Custom property for dynamic viewport height */
    --vh: 1vh;
  }

  html, body {
    background-color: ${colors.neutral.darkBrown};
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    overscroll-behavior: none;
    width: 100vw;
    /* Fix for mobile Safari viewport height issues */
    min-height: 100vh;
    min-height: -webkit-fill-available;
    min-height: calc(var(--vh, 1vh) * 100);
  }

  html {
    height: -webkit-fill-available;
  }

  /* Additional mobile Safari fixes */
  @supports (-webkit-appearance: none) {
    body {
      min-height: -webkit-fill-available;
    }
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
  width: 100%;
`;

const ContentWrapper = styled.div<{ $isMenuOpen: boolean }>`
  min-height: 100vh;
  /* Content should not shift when menu opens */
`;

const AppContent: React.FC = () => {
  const { isMenuOpen } = useMobileMenu();
  
  return (
    <AppContainer>
      <MobileNavigation />
      <ContentWrapper $isMenuOpen={isMenuOpen}>
        <Routes>
          <Route 
            path="/" 
            element={<HomePage />}
          />
          <Route 
            path="/rsvp" 
            element={<RSVPPage />}
          />
          <Route 
            path="/travel" 
            element={<TravelDetails />}
          />
          <Route 
            path="/registry" 
            element={<RegistryDetails />}
          />
        </Routes>
      </ContentWrapper>
    </AppContainer>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <GlobalStyle />
      <AuthProvider>
        <RSVPProvider>
          <MobileMenuProvider>
            <AppContent />
          </MobileMenuProvider>
        </RSVPProvider>
      </AuthProvider>
    </Router>
  );
};

export default App; 